import { createApp } from 'vue'
import './style.css'
import App from './App.vue'

createApp(App).mount('#app')

// Background color for using in stand-alone mode
try {
    if (window.self === window.top) {
        document.body.style.background = 'url(images/retro-background.png)';
        document.body.style.backgroundSize = 'cover';
    }
} catch (e) {}